// extracted by mini-css-extract-plugin
module.exports = {"background":"two-column_background__XN9nR","alt":"two-column_alt__2qCCv","container":"two-column_container__38qok"};